import { createSelector } from 'reselect';
import { RootState } from 'typesafe-actions';
import { getRegion, DEFAULT_KZ_REGION } from './location';
import { COMPARE_LIST_LIMIT_DEFAULT, COMPARE_LISTS_LIMIT_DEFAULT } from '../constants';

export const getEnv = createSelector(
  ({ env }: RootState) => env,
  (env) => env,
);

export const getOrchestratorHost = createSelector(
  getEnv,
  getRegion,
  ({ ORCHESTRATOR_HOST, ORCHESTRATOR_HOST_KZ, ORCHESTRATOR_BACKEND_HOST }, regionCode) => {
    if (__IS_SERVER__) {
      return ORCHESTRATOR_BACKEND_HOST;
    }

    if (regionCode === DEFAULT_KZ_REGION && ORCHESTRATOR_HOST_KZ) {
      return ORCHESTRATOR_HOST_KZ;
    }

    return ORCHESTRATOR_HOST;
  },
);

export const getProductsCompareOrchestratorHost = createSelector(
  getEnv,
  getRegion,
  (
    {
      PRODUCTS_COMPARE_ORCHESTRATOR_HOST,
      PRODUCTS_COMPARE_ORCHESTRATOR_HOST_KZ,
      PRODUCTS_COMPARE_ORCHESTRATOR_BACKEND_HOST,
    },
    regionCode,
  ) => {
    if (__IS_SERVER__) {
      return PRODUCTS_COMPARE_ORCHESTRATOR_BACKEND_HOST;
    }

    if (regionCode === DEFAULT_KZ_REGION && PRODUCTS_COMPARE_ORCHESTRATOR_HOST_KZ) {
      return PRODUCTS_COMPARE_ORCHESTRATOR_HOST_KZ;
    }

    return PRODUCTS_COMPARE_ORCHESTRATOR_HOST;
  },
);

export const getProductsCompareListLimit = createSelector(
  getEnv,
  ({ PRODUCTS_COMPARE_LIST_LIMIT }) => PRODUCTS_COMPARE_LIST_LIMIT || COMPARE_LIST_LIMIT_DEFAULT,
);

export const getProductsCompareListsLimit = createSelector(
  getEnv,
  ({ PRODUCTS_COMPARE_LISTS_LIMIT }) => PRODUCTS_COMPARE_LISTS_LIMIT || COMPARE_LISTS_LIMIT_DEFAULT,
);

export const getApiKey = createSelector(getEnv, ({ API_KEY, API_KEY_BACKEND }) =>
  __IS_SERVER__ ? API_KEY_BACKEND : API_KEY,
);

export const getUseGroupRatings = createSelector(getEnv, (env) => env?.USE_GROUP_RATINGS);
